import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'
import cookie from 'vue-cookie'
import { MessageBox, Message } from 'element-ui'
// import store from 'store/index'       //已经设置路径别名，否则相对路径引用
// 引入element-ui提示信息插件..

const request = axios.create({
  timeout: 50000,
  // baseURL: 'http://localhost:8080/thalesmart'
  baseURL: process.env.API_URL || 'shopvidi-en' // 我们在请求接口的时候就不同写前面 会自动我们补全
})

// http request 拦截器
request.interceptors.request.use(config => {
  const token = Vue.ls.get('token')
  if (token && token != null && token != undefined && token != 'null' && token != 'undefined') {
    config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  //add by cpgu 添加以下if逻辑，为了兼容mock 2023/03/13 begin
  if(process.env.NODE_ENV==='development'){
    config.headers.post['Content-Type'] = "appliction/json";
    config.headers.get['Content-Type'] = "appliction/json";
  }
  //end by cpgu

  return config
}, err => {
  return err
})

const err = (error) => {
  if (error.response) {
    // let data = error.response.data
    // const token = cookie.get('Access_Token')
    switch (error.response.status) {
      case 403:
        break
      case 500:
        let CUR_REQ_URL = error.config.url
        if (error.response.data && (error.response.data.message.includes('Token失效'))) {
          // setInterval方法，杜绝loop tips
          if (CUR_REQ_URL.includes('order/on-hold')) {
            break
          }
          else if (CUR_REQ_URL.includes('v0.2/orders/sample')) {
            break
          }

          Vue.ls.remove('token')
          window.location.href = window.location.origin
          localStorage.setItem('userlogin', 401)
        }

        break
      case 404:
        break
      case 504:
        break
      case 401:
        // if (token) {

        // /*  store.dispatch('Logout').then(() => {
        //     setTimeout(() => {
        //       window.location.reload()
        //     }, 1500)
        //   }) */
        // }
        Vue.ls.remove('token')
        window.location.href = window.location.origin
        localStorage.setItem('userlogin', 401)
        break
      default:
        break
    }
  }
  return Promise.reject(error)
}

// http response 拦截器
request.interceptors.response.use(response => {
  // 接收返回数据..
  const res = response.data
  // 判断返回数据是否存在状态code和错误提示信息..

  if (!res.code || !res.message) {
    // return showMessage('响应数据格式错误', 'error')
  }
  // 判断状态code是否为指定数值(200)..

  if (!res.success) {
    // return showMessage(res.msg || res.message, 'info')
    return res
  }

  return res
}, err)

// 获取跳转链接
function getEnvUrl() {
  let href = window.location.href
  let url = window.location.host
  if (href.indexOf('test') >= 0) {
    url = 'https://test-thalesmart-manage-ui.hupofintech.com'
    return url
  }
  if (href.indexOf('localhost') >= 0) {
    url = 'http://localhost:3000'
    return url
  }
  if (href.indexOf('shopvidi') >= 0) {
    url = 'https://p.shopvidi.com'
    return url
  }
}
// 封装错误提示信息..
function showMessage(msg, type) {
  Message({
    message: msg,
    type: type,
    duration: 3 * 1000
  })
  return Promise.reject()
}

export {request}



// WEBPACK FOOTER //
// ./src/utils/request.js